var render = function render(){var _vm=this,_c=_vm._self._c;return _c('capillary-locations-template',{attrs:{"first-blood-vessel-occurrance":_vm.firstBloodVesselOccurrance,"blood-vessel-locations":_vm.bloodVesselLocations,"gender":_vm.gender,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }